module.exports = __webpack_public_path__ + "img/pwa-install.0a7bff08.png";